import { Link, useMatch, useResolvedPath } from "react-router"
import './Navbar.css';


export default function Navbar() {
    return (
        <nav className="nav">
            <Link to="/" className="site-title">
                Intro
            </Link>
            <ul>
                <CustomLink to="/dev">Development</CustomLink>
                <CustomLink to="/contact">Contact</CustomLink>
            </ul>
        </nav>
    )
}

interface LinkProps {
    children: React.ReactNode;
    to: string;
}

function CustomLink({ to, children, ...props }: LinkProps) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
        <li className={isActive ? "active" : ""}>
            <Link to={to} {...props}>
                {children}
            </Link>
        </li>
    )
}
